import React from "react";
import Logo from "../../assets/images/praylo-logo.png";
import VideoFirst from "../../assets/images/backgroud-video/1.mp4";
import VideoTwo from "../../assets/images/backgroud-video/2.mp4";
import Apple from "../../assets/images/apple.png";
import Android from "../../assets/images/android.png";
import Plus from "../../assets/images/plus.png";

const LandingPage = () => {
  return (
    <div className="god-bg rounds relative z-50 p-5 min-h-screen w-full flex items-center justify-center overflow-hidden">
      <div className="absolute top-0 left-0 -z-10 h-screen w-screen rounded-none opacity-30 bg-light">
        <video
          src={VideoFirst}
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover bg-center"
        />
      </div>
      <div className="absolute top-0 left-0 -z-20 h-screen w-screen rounded-none">
        <video
          src={VideoTwo}
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover bg-center"
        />
      </div>
      <div className="h-full relative z-50">
        <div className="h-fit grid gap-5 lg:gap-30">
          <div
            className="xl2:h-[241px] xl2:w-[600px] lg:w-[448px] tab:w-[299px] w-[199px] lg:h-[180px] tab:h-[120px] h-20 mx-auto wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.3s"
          >
            <img src={Logo} alt="" className="h-full w-full" />
          </div>
          <h3
            className="text-3xl tab:text-4xl lg:text-5xl xl:text-70 lg:leading-[130%] text-center font-bold wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.3s"
          >
            Strengthen Your Faith
          </h3>
          <div className="grid tab:flex tab:items-end">
            <div
              className="lg:h-[100px] lg:w-[320px] h-12 w-[154px] mb-4 tab:mb-7 max-lg:mx-auto max-tab:order-2 tab:-mr-9 relative z-20 wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <a href="https://apps.apple.com/us/app/praylo/id6744596984">
                <img src={Apple} alt="" className="w-full h-full" />
              </a>
            </div>
            <div
              className="max-tab:order-1 max-tab:h-20 max-tab:w-fit max-tab:mx-auto max-tab:mb-4 wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <img src={Plus} alt="" className="max-tab:h-full" />
            </div>
            <div
              className="lg:h-[100px] lg:w-[320px] h-12 w-[154px] tab:mb-7 max-lg:mx-auto max-tab:order-3 tab:-ms-9 relative z-20 wow animate__animated animate__fadeIn"
              data-wow-duration="1s"
              data-wow-delay="0.3s"
            >
              <a href="https://play.google.com/store/apps/details?id=com.praylo.app">
                <img src={Android} alt="" className="w-full h-full" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
